var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E-Commerce/shop fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72412 1.5H5.27588L4.66862 4.05052C4.70317 4.50129 5.19533 5 6 5C6.80467 5 7.29683 4.50128 7.33138 4.05052L6.72412 1.5Z",
    fill: "#818CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75207 1.5L8.33333 3.9413V4C8.33333 4.46315 8.83179 5 9.66667 5C10.0023 5 10.2836 4.91322 10.5 4.77933V4.37776C10.5 4.2369 10.5 4.16647 10.4903 4.09748C10.4818 4.03622 10.4675 3.97588 10.4478 3.91724C10.4256 3.85122 10.3941 3.78823 10.3311 3.66223L9.69222 2.38447C9.5317 2.06341 9.45143 1.90287 9.33168 1.78559C9.22579 1.68187 9.09816 1.60299 8.95803 1.55466C8.79958 1.5 8.6201 1.5 8.26113 1.5H7.75207Z",
    fill: "#818CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.86657C10.235 5.95359 9.9522 6 9.66667 6C8.96396 6 8.27765 5.71893 7.83333 5.243C7.38902 5.71893 6.7027 6 6 6C5.2973 6 4.61099 5.71893 4.16667 5.243C3.72235 5.71893 3.03604 6 2.33333 6C2.0478 6 1.76498 5.95359 1.5 5.86657V7.30001C1.5 8.42012 1.5 8.98017 1.71799 9.40799C1.90973 9.78432 2.21569 10.0903 2.59202 10.282C2.99359 10.4866 3.51165 10.4992 4.5 10.5V8.5C4.5 7.94772 4.94772 7.5 5.5 7.5H6.5C7.05228 7.5 7.5 7.94772 7.5 8.5V10.5C8.48835 10.4992 9.00641 10.4866 9.40798 10.282C9.7843 10.0903 10.0903 9.78432 10.282 9.40799C10.5 8.98017 10.5 8.42012 10.5 7.30001V5.86657Z",
    fill: "#818CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.77933C1.71637 4.91322 1.99766 5 2.33333 5C3.16821 5 3.66667 4.46315 3.66667 4V3.9413L4.24793 1.5H3.58326C3.19214 1.5 2.99657 1.5 2.82749 1.56308C2.67809 1.61882 2.54418 1.70948 2.43695 1.8275C2.31558 1.96106 2.24295 2.14263 2.0977 2.50579L1.61443 3.71397C1.57168 3.82086 1.5503 3.87431 1.53526 3.92943C1.5219 3.9784 1.51229 4.02831 1.50651 4.07874C1.5 4.1355 1.5 4.19306 1.5 4.30819V4.77933Z",
    fill: "#818CF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brand_icon.2426d2afcff193e9aed512c2af999af5.svg";
export { ForwardRef as ReactComponent };